<template> 
    <v-dialog 
        v-model="dialogoMensajeRetornarCentral"
        persistent 
        max-width="800px"
        fullscreen
    >
        <v-card  style="border: 2px solid black">
            <div class="text-center py-6">
                <v-alert dense outlined type="error" v-if="alertError">
                    No fue posible la comunicación con <strong>API SERVICE</strong> ponganse en contacto con el administrador si este mensaje persiste.
                </v-alert>                
                <v-icon size="50" color="success">fas fa-exchange-alt</v-icon>
                <h2 class="titulomensaje">¿Está seguro que desea retornar {{datosMaterialInsumo.TituloMaterial}} a bodega?</h2>
                <!-- <h2 class="titulomensaje">{{tituloMensajeEliminar}}</h2> -->
            </div>
            <hr class="mt-2">
            <div class="text-center pt-5 pb-5" style="background-color: #CCFFB4">
                <span class="fuenteTitulo mr-5"><strong>Material o Insumo:</strong> {{datosMaterialInsumo.Nombre}} </span> 
                <span class="fuenteTitulo mr-5"><strong>Marca:</strong> {{datosMaterialInsumo.Marca}} </span>  <br>
                <span class="fuenteTitulo mr-5"><strong>Unidad de Medida:</strong> {{datosMaterialInsumo.UnidadDeMedida}} </span> 
                <span class="fuenteTitulo mr-5"><strong>Cantidad transferida:</strong> {{datosMaterialInsumo.Cantidad}} </span> 
            </div>
            <hr> <br>
            <v-card-text>
                <v-alert v-if="ActivarAlertaCantidadExtraviadaPorElUsuario" dense
                    outlined
                    type="warning"
                    prominent
                    border="left"
                >
                    Está acción generará un descuento a planilla del usuario a cargo
                </v-alert>                
                <v-form v-model="valid" ref="form" :lazy-validation="lazy" autocomplete="off">
                    <v-row wrap>
                        <v-col cols="12" lg="3" md="6" sm="12" class="mt-0 pt-0 mb-0 pb-0">
                            <v-text-field required :rules="ReglasFormulario"
                                outlined type="number" 
                                label="Cantidad Utilizada"
                                v-model="cantidadUtilizada"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" lg="3" md="6" sm="12" class="mt-0 pt-0 mb-0 pb-0">
                            <v-text-field required :rules="ReglasFormulario"
                                outlined type="number" 
                                label="Cantidad Sobrante"
                                v-model="cantidadSobrante"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" lg="3" md="6" sm="12" class="mt-0 pt-0 mb-0 pb-0">
                            <v-text-field required :rules="ReglasFormulario" 
                                outlined type="number"
                                label="Cantidad Extraviada"
                                v-model="CantidadExtraviadaPorElUsuario"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" lg="3" md="6" sm="12" class="mt-0 pt-0 mb-0 pb-0">
                            <v-text-field required :rules="ReglasFormulario" 
                                outlined type="number"
                                label="Cantidad Arruinada"
                                v-model="CantidadArruinada"
                            ></v-text-field>                
                        </v-col>
                        <v-col cols="12" lg="4" md="6" sm="12" class="mt-0 pt-0 mb-0 pb-0">
                            <v-textarea outlined label="Observación de Cantidad Sobrante" v-model="modeloRetornarMaterial.observacionCantidadSobrante"
                            :disabled="!ActivarObservacionCantidadSobrante"></v-textarea>
                        </v-col>
                        <v-col cols="12" lg="4" md="6" sm="12" class="mt-0 pt-0 mb-0 pb-0">
                            <v-textarea outlined label="Observación de Cantidad Extraviada" v-model="modeloRetornarMaterial.observacionCantidadExtraviada"
                            :disabled="!ActivarObservacionCantidadExtraviada"></v-textarea>
                        </v-col>                        
                        <v-col cols="12" lg="4" md="6" sm="12" class="mt-0 pt-0 mb-0 pb-0">
                            <v-textarea outlined label="Observación de Cantidad Arruinada" v-model="modeloRetornarMaterial.observacionCantidadArruinada"
                            :disabled="!ActivarObservacionCantidadArruinada"></v-textarea>
                        </v-col>                        
                    </v-row>
                </v-form>
                <v-alert v-if="ActivarAlertaCantidadesMayorCantidadTransferida" dense
                    outlined
                    type="error"
                    prominent
                    border="left"
                >
                    Lo siento, la sumatoria de cantidad recibida, extraviada y arruinada no es igual a la cantidad transferida.
                </v-alert>                                
                <v-alert v-if="ActivarAlertaCantidadesSonIguales" dense
                    outlined
                    type="success"
                    prominent
                    border="left"
                >
                    Bien! La sumatoria de las cantidades es igual a la cantidad transferida.
                </v-alert>                                
            </v-card-text>
            <hr>
            <v-card-actions class="pb-6">
                <v-spacer></v-spacer>
                <v-btn large rounded class="mx-2" color="success" @click="RetornarMaterialInsumoABodega()"
                    :loading="loadingMensajeRetornarCentral" :disabled="loadingMensajeRetornarCentral || !DesactivarBotonRealizarTransaccion"
                >Si, retornar a bodega
                    <v-icon right dark>fas fa-save</v-icon>
                </v-btn>            
                <v-btn dark large rounded class="mx-2" color="error" @click="CerrarModalRetornarMaterialBodega()">Cancelar
                    <v-icon right dark>far fa-window-close</v-icon>
                </v-btn>                        </v-card-actions>
        </v-card>        
    </v-dialog>        
</template>

<script>
import { showMessageSuccess } from '../../../services/sweetAlert'
export default {
    props:{
        dialogoMensajeRetornarCentral: Boolean,
        datosMaterialInsumo: Object,
        alertError: Boolean,
    },

    data() {
        return {
            // variables para retornar herramientas a sucursal central
            valid: false,
            lazy: false,      
            ReglasFormulario: [
                v => !!v || 'Campo es requerido',
            ],
            modeloRetornarMaterial:{
                idProyecto: 0,
                idMaterial:0,
                cantidadUtilizada:'',
                cantidadExtraviada:'',
                observacionCantidadExtraviada:"",
                cantidadArruinada:'',
                observacionCantidadArruinada:"",
                cantidadSobrante:'',
                observacionCantidadSobrante:"",
            },
            loadingMensajeRetornarCentral: false,
            cantidadUtilizada:0,
            CantidadExtraviadaPorElUsuario:0,
            CantidadArruinada:0,
            cantidadSobrante:0,

            ActivarAlertaCantidadExtraviadaPorElUsuario: false,
            TotalCantidades:0,
            ActivarObservacionCantidadExtraviada:false,
            ActivarObservacionCantidadArruinada:false,
            ActivarObservacionCantidadSobrante:false,

            ActivarAlertaCantidadesMayorCantidadTransferida: false,
            ActivarAlertaCantidadesSonIguales: false,
            DesactivarBotonRealizarTransaccion:false,
        }
    },

    watch: {
        dialogoMensajeRetornarCentral(){
            // console.log('datosMaterialInsumo: ', this.datosMaterialInsumo)
        },
        dialogoMensajeRetornarCentral(){
            this.cantidadUtilizada = this.datosMaterialInsumo.Cantidad
            this.cantidadSobrante = 0
            this.CantidadExtraviadaPorElUsuario = 0
            this.CantidadArruinada = 0
        },

        CantidadExtraviadaPorElUsuario(){
            if(this.CantidadExtraviadaPorElUsuario > 0){
                 this.ActivarAlertaCantidadExtraviadaPorElUsuario = true
                 this.ActivarObservacionCantidadExtraviada =true
            }else {
                this.ActivarAlertaCantidadExtraviadaPorElUsuario = false
                this.ActivarObservacionCantidadExtraviada = false
            }
            this.CalcularTotal()
        },

        cantidadUtilizada (){
            this.CalcularTotal()
        },

        CantidadArruinada (){
            if(this.CantidadArruinada>0) this.ActivarObservacionCantidadArruinada = true;
            else this.ActivarObservacionCantidadArruinada = false;
            this.CalcularTotal()
        },

        cantidadSobrante(){
            if(this.cantidadSobrante>0) this.ActivarObservacionCantidadSobrante = true;
            else this.ActivarObservacionCantidadSobrante = false;
            this.CalcularTotal()
        }
    },

    methods: {
        CalcularTotal(){
            this.TotalCantidades = parseFloat(this.cantidadUtilizada) + parseFloat(this.CantidadExtraviadaPorElUsuario) + parseFloat(this.CantidadArruinada) + parseFloat(this.cantidadSobrante)
            if(this.TotalCantidades > this.datosMaterialInsumo.Cantidad || this.TotalCantidades < this.datosMaterialInsumo.Cantidad){
                this.ActivarAlertaCantidadesMayorCantidadTransferida = true
                this.ActivarAlertaCantidadesSonIguales = false
            }else if(this.TotalCantidades === this.datosMaterialInsumo.Cantidad){
                this.ActivarAlertaCantidadesMayorCantidadTransferida = false
                this.ActivarAlertaCantidadesSonIguales = true
                this.DesactivarBotonRealizarTransaccion = true
            }else if(this.TotalCantidades != this.datosMaterialInsumo.Cantidad){
                this.DesactivarBotonRealizarTransaccion = false
            }            
        },

        CerrarModalRetornarMaterialBodega(){
            this.$emit('CerrarModalRetornarMaterialBodega')
            this.ActivarAlertaCantidadesSonIguales = false
        },

        async RetornarMaterialInsumoABodega(){            
            this.loadingMensajeRetornarCentral = true
            this.modeloRetornarMaterial.idProyecto = this.datosMaterialInsumo.idProyecto
            this.modeloRetornarMaterial.idMaterial = this.datosMaterialInsumo.idMaterial
            this.modeloRetornarMaterial.cantidadUtilizada = this.cantidadUtilizada
            this.modeloRetornarMaterial.cantidadExtraviada = this.CantidadExtraviadaPorElUsuario
            this.modeloRetornarMaterial.cantidadArruinada = this.CantidadArruinada
            this.modeloRetornarMaterial.cantidadSobrante = this.cantidadSobrante
            // console.log('this.modeloRetornarMaterial: ', this.modeloRetornarMaterial)
            if(this.$refs.form.validate()){
                if(this.ActivarAlertaCantidadesSonIguales){
                    const response = await this.$store.dispatch('RetornarMaterialABodegaByIdMaterial', this.modeloRetornarMaterial)
                    if(response.status === 200){
                        this.loadingMensajeRetornarCentral = false
                        this.$emit('ObtenerInventarioMaterialInsumosPorSucursal')
                        this.alertError= false
                        this.CerrarModalRetornarMaterialBodega()
                        showMessageSuccess('BIEN!', 'Material o Insumo retornado exitosamente a bodega.')
                    }else{
                        this.responseStatus = response
                        this.loadingMensajeRetornarCentral = false
                    }
                }else{
                    this.ActivarAlertaCantidadesSonIguales = false
                }
            }else{
                this.loadingMensajeRetornarCentral = false
            }
        }        
    },
}
</script>